module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result19-48a2adcbd10aa7bb500a0f543ba5f6d1.png";